<template>
  <div>
    <v-btn
      class="info font-weight-bold"
      :color="showAutoLabel ? 'warning' : 'info'"
      @click="showDialog"
      ><span class="d-none d-sm-flex">自動更新</span
      ><span class="d-sm-none">自動更新</span>
      <span v-if="showAutoLabel" class="auto_on">設定済</span>
      <span v-else class="auto_off">未設定</span>
    </v-btn>
    <!-- スケジュール自動更新設定ダイアログ -->
    <v-dialog
      v-model="dialog"
      scrollable
      persistent
      width="100%"
      max-width="640px"
    >
      <v-card :loading="disabled" :disabled="disabled">
        <v-card-title>
          <span class="text-h5">スケジュール自動更新設定</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="cancelDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <h3>更新時刻</h3>
          <div class="mt-2 mb-2">
            指定した時刻にスケジュールの更新を行います。<span class="text-red"
              >最大6回/日</span
            >まで設定可能です。更新間隔は<span class="text-red"
              >1時間(60分)以上</span
            >あけて設定して下さい。
          </div>
          <div v-for="(time, index) in synchroTimes" :key="index">
            <div class="d-flex align-center">
              <span class="mr-2">{{ index + 1 }}.</span>
              <time-selector-component
                ref="refTimeSelector"
                :p_hour="time.hour"
                :p_minute="time.minute"
              />
            </div>
          </div>
          <h3 class="mt-8">更新したい媒体を選択</h3>
          <div class="mt-2 mb-2">更新したい媒体を選択して下さい。</div>
          <v-container>
            <v-row>
              <v-col cols="12">
                <!-- テーブル -->
                <v-data-table
                  :headers="allSyncHeaders"
                  :items="allSyncSiteList"
                  :mobile-breakpoint="0"
                  item-key="shop_site_id"
                  show-select
                  :single-select="false"
                  v-model="allSyncSelected"
                  :footer-props="{ 'items-per-page-options': [-1] }"
                  hide-default-footer
                  @click:row="rowClick"
                >
                  <template v-slot:no-data>
                    表示するデータがありません
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-container>
          <h3 class="mt-8">自動更新</h3>
          <div class="mt-2 mb-2">
            ONにすると指定した時刻にスケジュールを更新します。
          </div>
          <v-container>
            <v-row>
              <v-col cols="12" sm="4">
                <v-switch
                  v-model="is_auto"
                  :label="`${is_auto ? 'ON' : 'OFF'}`"
                ></v-switch>
              </v-col>
            </v-row>
          </v-container>
          <div class="mt-8 font-bold">【オプション】</div>
          <h3 class="mt-0">更新前に媒体からスケジュールを取り込む</h3>
          <div class="mt-2 mb-2">
            自動更新の前に指定した媒体からスケジュールを取り込みたい場合は設定してください。
          </div>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-select
                  prepend-icon="mdi-web"
                  v-model="shopSiteId"
                  :items="shopSites"
                  item-value="id"
                  item-text="name"
                  no-data-text="更新管理にて媒体を登録して下さい"
                  label="媒体選択"
                  success
                  outlined
                ></v-select>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-container>
            <v-row justify="end">
              <v-col cols="6" sm="6">
                <general-button
                  btn_color="gray"
                  btn_block
                  @click-event="cancelDialog"
                  ><template v-slot:icon
                    ><v-icon left>mdi-close-circle</v-icon></template
                  >キャンセル</general-button
                >
              </v-col>
              <v-col cols="6" sm="6">
                <general-button
                  btn_type="info"
                  btn_block
                  @click-event="onSubmit"
                  ><template v-slot:icon
                    ><v-icon left>mdi-content-save</v-icon></template
                  >保存</general-button
                >
              </v-col>
            </v-row>
          </v-container>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {
  ref,
  reactive,
  watch,
  toRefs,
  defineComponent,
} from "@vue/composition-api";
import store from "@/store/index.js";
import { repositoryFactory } from "@/repository/repositoryFactory";
import { useRouter } from "@/utils";
import setting from "@/common/setting.js";
import selectITem from "@/common/selectItem.js";
import _ from "lodash";
import timeSelectorComponent from "./timeSelector.vue";

export default defineComponent({
  props: ["show_dialog"],
  components: {
    timeSelectorComponent,
  },
  setup(props, ctx) {
    const { router } = useRouter();
    const ShopPropsRepository = repositoryFactory.get("shopProps");
    const ShopSitesRepository = repositoryFactory.get("shopSites");
    const refForm = ref();
    const refTimeSelector = ref();

    const state = reactive({
      dialog: false, // ダイアログ表示用
      disabled: false,
      showAutoLabel: false, // 自動更新設定中ラベル表示有無

      synchroTimes: [], // 自動更新設定時刻
      allSyncSiteList: [], // 自動更新対象サイト一覧
      allSyncSelected: [], // 自動更新対象サイト選択済み一覧
      allSyncHeaders: [
        {
          text: "サイト名",
          value: "site_name",
          sortable: false,
        },
      ],
      is_auto: false, // 自動更新ON/OFF
      shopSites: [], // 店舗媒体一覧(スケジュールが取込出来る媒体)
      shopSiteId: 0,
      defaultShopSiteId: 0,
    });

    const showDialog = async () => {
      const params = new URLSearchParams();
      params.append("shop_id", store.getters["shops/currentShop"].id);

      // 自動 更新サイト一覧取得
      state.allSyncSiteList.splice(0);
      state.allSyncSelected.splice(0);
      await ShopSitesRepository.list_getschedule_update(params)
        .then((response) => {
          if (response.data) {
            Object.keys(response.data).forEach(function (key) {
              // HP連携はスケジュール更新から除外する
              if (
                response.data[key].sites_category !=
                setting.site_category_hp_link
              ) {
                const data = {
                  shop_site_id: response.data[key].id,
                  site_content_id: response.data[key].site_content_id,
                  site_name:
                    response.data[key].sites_name +
                    (JSON.parse(response.data[key].config).memo != ""
                      ? " [ " +
                        JSON.parse(response.data[key].config).memo +
                        " ] "
                      : ""),
                  site_id: response.data[key].site_id,
                };
                state.allSyncSiteList.push(data);
                state.allSyncSelected.push(data);
              }
            });
          }
        })
        .catch((error) => {
          throw "ERROR:データ取得エラー (" + error + ")";
        });

      // 取込可能サイト一覧取得
      state.shopSites.splice(0);
      state.shopSites.push({ id: 0, name: "設定しない" });
      await ShopSitesRepository.list_getschedule(params)
        .then((response) => {
          if (response.data) {
            Object.keys(response.data).forEach(function (key) {
              // HP連携と風俗CTIv2はスケジュール取り込みから除外する
              if (
                response.data[key].sites_category !=
                  setting.site_category_hp_link &&
                response.data[key].site_id != setting.cit2_fuzoku_fan_site_id
              ) {
                state.shopSites.push({
                  "id": response.data[key].id,
                  "name":
                    response.data[key].sites_name +
                    (JSON.parse(response.data[key].config).memo != ""
                      ? " [ " +
                        JSON.parse(response.data[key].config).memo +
                        " ] "
                      : ""),
                });
              }
            });
            if (state.shopSites.length > 0) {
              state.shopSiteId = state.shopSites[0].id;
            }
          }
        })
        .catch((error) => {
          throw "ERROR:データ取得エラー (" + error + ")";
        });

      // shop_propsから自動更新設定値取得
      const shop_data = store.getters["shops/currentShop"].data;
      if (shop_data.prop) {
        for (let j = 0; j < shop_data.prop.length; j++) {
          switch (shop_data.prop[j].key) {
            case setting.shop_prop_key_aus_times: // 自動更新時刻
              {
                const times = shop_data.prop[j].value.split(",");
                for (let i = 0; i < state.synchroTimes.length; i++) {
                  if (i < times.length) {
                    const timeParts = times[i].split(":");
                    state.synchroTimes[i].hour = parseInt(timeParts[0]);
                    state.synchroTimes[i].minute = parseInt(timeParts[1]);
                  } else {
                    state.synchroTimes[i].hour = null;
                    state.synchroTimes[i].minute = null;
                  }
                }
              }
              break;
            case setting.shop_prop_key_aus_export_shop_site_ids: // 自動更新対象サイト
              {
                const siteIds = shop_data.prop[j].value.split(",");
                state.allSyncSelected.splice(0);
                for (let i = 0; i < state.allSyncSiteList.length; i++) {
                  if (
                    siteIds.includes(
                      state.allSyncSiteList[i].shop_site_id.toString()
                    )
                  ) {
                    state.allSyncSelected.push(state.allSyncSiteList[i]);
                  }
                }
              }
              break;
            case setting.shop_prop_key_aus_import_shop_site_id: // 更新前にスケジュール取込を行う媒体ID
              {
                state.shopSiteId = parseInt(shop_data.prop[j].value);
              }
              break;
          }
        }
      }

      state.dialog = true;
    };

    const updateShopProps = async (key, value) => {
      const shopData = store.getters["shops/currentShop"].data;
      let prop = {
        id: 0,
        shop_id: shopData.id,
        key: key,
        value: value,
      };
      if (shopData.prop == null) {
        shopData.prop = [];
      }
      // 既存データがある場合、idをセット
      for (let j = 0; j < shopData.prop.length; j++) {
        if (shopData.prop[j].key == key) {
          prop.id = shopData.prop[j].id ?? 0;
          break;
        }
      }
      // shop_propsの更新
      const params = {
        id: prop.id,
        shop_id: prop.shop_id,
        key: prop.key,
        value: prop.value,
      };
      if (prop.id != 0) {
        // DBの更新
        await ShopPropsRepository.update(params)
          .then((response) => {
            if (response.data) {
              // データ追加OK
              prop.id = response.data.id;
            }
          })
          .catch((error) => {
            throw "ERROR:autoSyncroSet.vue/updateShopProps (" + error + ")";
          });
      } else {
        // DBに追加
        await ShopPropsRepository.create(params)
          .then((response) => {
            if (response.data) {
              // データ追加OK
              prop.id = response.data.id;
            }
          })
          .catch((error) => {
            throw "ERROR:autoSyncroSet.vue/updateShopProps (" + error + ")";
          });
      }
      // vuexの更新
      store.dispatch("shops/setProp", {
        id: prop.id,
        key: prop.key,
        value: prop.value,
      });
    };

    // 保存処理
    const onSubmit = async () => {
      // 時刻チェック
      for (let i = 0; i < state.synchroTimes.length; i++) {
        const timeSelectorRef = ctx.refs["refTimeSelector"][i];
        if (!timeSelectorRef.checkForm()) {
          alert("時刻指定に誤りがあります。");
          return false;
        }
        const timeData = timeSelectorRef.getTime();
        state.synchroTimes[i].hour = timeData.hour;
        state.synchroTimes[i].minute = timeData.minute;
      }
      // 時刻が重複していないかチェック、一つ以上設定されているかチェック
      const timeSet = new Set();
      let atLeastOneSet = false;
      for (let i = 0; i < state.synchroTimes.length; i++) {
        const time = state.synchroTimes[i];
        if (time.hour != null && time.minute != null) {
          atLeastOneSet = true;
          const timeKey = `${time.hour}:${time.minute}`;
          if (timeSet.has(timeKey)) {
            alert("同じ時刻が複数設定されています。");
            return false;
          }
          timeSet.add(timeKey);
        }
      }
      // state.synchroTimesを昇順にソートし、時間の前後が60分以上離れているかチェック
      const validTimes = state.synchroTimes
        .filter((t) => t.hour != null && t.minute != null)
        .map((t) => t.hour * 60 + t.minute)
        .sort((a, b) => a - b);
      for (let i = 0; i < validTimes.length; i++) {
        const current = validTimes[i];
        const next = validTimes[(i + 1) % validTimes.length];
        // 差分を正しく計算（24時間をまたぐ場合も考慮）
        let diff = next - current;
        if (diff <= 0) diff += 24 * 60;
        if (diff < 60) {
          alert(
            `更新時刻は1時間(60分)以上間隔をあけて設定して下さい。\n(${Math.floor(
              current / 60
            )}:${("00" + (current % 60)).slice(-2)} と ${Math.floor(
              next / 60
            )}:${("00" + (next % 60)).slice(-2)} の間隔が短すぎます)`
          );
          return false;
        }
      }

      // 自動更新がOFFの時は、この先のチェックを行わない
      if (state.is_auto) {
        if (!atLeastOneSet) {
          alert("一つ以上の更新時刻を設定して下さい。");
          return false;
        }

        // 自動更新対象サイトが選択されているかチェック
        if (state.allSyncSelected.length == 0) {
          alert("自動更新対象の媒体を1つ以上選択して下さい。");
          return false;
        }
        if (
          !state.showAutoLabel &&
          !confirm("媒体へのスケジュール自動更新を開始します。よろしいですか？")
        ) {
          return false;
        }
      } else {
        // 自動更新をOFFにする時、確認メッセージを表示する
        if (
          state.showAutoLabel &&
          !confirm(
            "自動更新をOFFにして、よろしいですか？\n媒体へのスケジュール更新は停止します。"
          )
        ) {
          return false;
        }
      }

      // ローディング表示
      store.dispatch("loadingIcon/showIcon");
      state.disabled = true;

      // 保存処理
      // 自動更新時刻保存 setting.shop_prop_key_aus_timesに、"10:00,11:00,04:00" カンマ区切りで複数指定可能
      const aus_times = [];
      for (let i = 0; i < state.synchroTimes.length; i++) {
        if (
          state.synchroTimes[i].hour != null &&
          state.synchroTimes[i].minute != null
        ) {
          aus_times.push(
            ("00" + state.synchroTimes[i].hour).slice(-2) +
              ":" +
              ("00" + state.synchroTimes[i].minute).slice(-2)
          );
        } else {
          state.synchroTimes[i] = { hour: null, minute: null };
        }
      }
      const aus_times_str = aus_times.join(",");

      // 自動更新対象サイト保存 setting.shop_prop_key_aus_export_shop_site_ids #shop_site_id "1,2,3" カンマ区切りで複数指定可能
      const aus_export_shop_site_ids = state.allSyncSelected
        .map((item) => item.shop_site_id)
        .join(",");

      // 自動更新ON/OFF保存 setting.shop_prop_key_auto_update_schedule "true" or "false"
      const aus_is_auto = state.is_auto ? "true" : "false";

      // 更新前に媒体からスケジュールを取り込む媒体ID保存 setting.shop_prop_key_aus_import_shop_site_id #shop_site_id
      const aus_import_shop_site_id = state.shopSiteId.toString();

      // DB更新処理&vuex更新処理
      await updateShopProps(setting.shop_prop_key_aus_times, aus_times_str);
      await updateShopProps(
        setting.shop_prop_key_aus_export_shop_site_ids,
        aus_export_shop_site_ids
      );
      await updateShopProps(
        setting.shop_prop_key_auto_update_schedule,
        aus_is_auto
      );
      await updateShopProps(
        setting.shop_prop_key_aus_import_shop_site_id,
        aus_import_shop_site_id
      );

      // 自動更新設定表示判定更新
      state.showAutoLabel = state.is_auto;

      // ローディング非表示
      store.dispatch("loadingIcon/hideIcon");
      state.disabled = false;

      // ダイアログ閉じる
      state.dialog = false;
    };

    const init = () => {
      // 自動更新設定用の配列を初期化
      state.synchroTimes.splice(0);
      for (let i = 0; i < 6; i++) {
        state.synchroTimes.push({ hour: null, minute: null });
      }

      // 更新中かどうかの設定表示判定
      const shop_data = store.getters["shops/currentShop"].data;
      state.showAutoLabel = false;
      if (shop_data.prop) {
        for (let j = 0; j < shop_data.prop.length; j++) {
          if (
            shop_data.prop[j].key == setting.shop_prop_key_auto_update_schedule
          ) {
            if (shop_data.prop[j].value == "true") {
              state.showAutoLabel = true;
              state.is_auto = true;
              break;
            }
          }
        }
      }
      // console.log("現在のshop_data:", shop_data);
    };

    init();

    // ダイアログキャンセルボタン
    const cancelDialog = () => {
      state.post_hour = null;
      state.post_minute = null;
      state.dialog = false;
    };

    const rowClick = (item, row) => {
      row.select(!row.isSelected);
    };

    return {
      setting,
      selectITem,
      refTimeSelector,
      ...toRefs(state),
      refForm,
      onSubmit,
      cancelDialog,
      showDialog,
      rowClick,
    };
  },
});
</script>

<style scoped>
.flex_center {
  display: flex;
  justify-content: center;
  align-items: center;
}
.select_item {
  width: 5em;
}
::v-deep .auto_on {
  display: inline-block;
  margin-left: 4px;
  padding: 4px;
  background-color: white;
  border-radius: 3px;
  font-size: 0.75em;
  font-weight: bold;
  color: #fb8c00;
  animation: blinking 1s ease-in-out infinite alternate;
}
@keyframes blinking {
  0% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
}

::v-deep .auto_off {
  display: inline-block;
  margin-left: 4px;
  padding: 4px;
  background-color: white;
  font-size: 0.75em;
  border-radius: 3px;
  font-weight: bold;
  color: #2196f3;
}
</style>
